import mannequin from '../../assets/avatar/basic.webp?url';
import wornIndex from '../../assets/items/worn/index.json';
import catalogJson from '../../server/api/data/items.json';
import type { Slot } from './outfit';

/**
 * The art the apps draw an avatar from: the mannequin, and each item's worn layer with its box. All of it is
 * bundled into the admin build, so the Mannequin page needs no request and no other host.
 */
const files = import.meta.glob('../../assets/items/worn/*.webp', { eager: true, query: '?url', import: 'default' }) as Record<string, string>;

const urls = new Map<string, string>();
for (const [path, url] of Object.entries(files)) urls.set(path.slice(path.lastIndexOf('/') + 1, -'.webp'.length), url);

/** A box on the avatar's square canvas: left, top, right, bottom as fractions. */
export type Box = readonly [number, number, number, number];

const boxes = wornIndex as unknown as Record<string, Box>;

export const mannequinUrl: string = mannequin;

export interface CatalogEntry {
  id: string;
  name: string;
  rarity: string;
  emoji: string;
  slot: Slot;
}

export const catalogItems: readonly CatalogEntry[] = (catalogJson as { items: CatalogEntry[] }).items;

/** Every worn-layer id with a box in the index, and every id with a file: for tests of the art itself. */
export const wornIds = { boxes: Object.keys(boxes), files: [...urls.keys()] };

/** The item's worn layer and where it sits, or `null` when it has no box or no file. */
export function wornLayer(itemId: string): { url: string; box: Box } | null {
  const box = boxes[itemId];
  const url = urls.get(itemId);
  return box && url ? { url, box } : null;
}
